// extracted by mini-css-extract-plugin
export default {"backGroundImg":"main_backGroundImg__0Zrpi","iconsBlock":"main_iconsBlock__D+q2W","arrow":"main_arrow__rJgem"};